import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";


interface RecaptchaState {
  publicCaptchaKey?: string;
  captchaResponse?: string;
  captchaUuid?: string
}

const initialState: RecaptchaState = {};

const recaptchaSlice = createSlice({
  name: "recaptcha",
  initialState,
  reducers: {
    setPublicCaptchaKey(state, action) {
      state.publicCaptchaKey = action.payload;
    },
    setCaptchaResponse(state, action) {
      state.captchaResponse = action.payload;
    },
    setCaptchaUuid(state, action) {
      state.captchaUuid = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});


export default recaptchaSlice.reducer;
export const {
  setPublicCaptchaKey,
  setCaptchaResponse,
  setCaptchaUuid,
  destroy
} = recaptchaSlice.actions;
export const recaptchaActions = recaptchaSlice.actions;
